<life-di-nav></life-di-nav>

<div *ngIf="payment" class="container justify-content-center">
  <h1 class="lifedi-color text-left m-3">
    รายการ
  </h1>
  <div class="row mx-3 mt-4 mb-4">
    <div class="col-lg-8">
      <img [src]="payment.IMAGE" alt="" class="text-left mr-5 float-left object-fit: cover;"
        style="width: 100px; height: 100px;">
      <h3 class="float-left pt-4 mt-2" style="font-size: x-large;">{{ payment.TITLE }}</h3>
    </div>
    <div class="col-lg-4">
      <h3 class="text-right pt-4 mt-2" style="color: #DE5C8B;">{{ payment.PRICE | number }} บาท</h3>
      <p *ngIf="type === 'workshop'" class="text-right mt-2 lifedi-color">โปรดดำเนินการให้แล้วเสร็จภายในวันที่</p>
      <p *ngIf="type === 'workshop'" class="text-right mt-2 lifedi-color"> {{ payment.EXP_DATE | date }}</p>
    </div>
    <hr width="100%">
  </div>

  <div class="container pb-3">
    <div class="row">
      <div class="col-12 col-sm-8 col-md-6 mx-auto">
        <mat-card>
          <form [formGroup]="billerForm" class="needs-validation">
            <h5 class="text-left m-3">ที่อยู่สำหรับออกใบเสร็จ</h5>
            <div class="row mb-3 mt-3 d-flex justify-content-center">
              <div class="col-lg-9 col-md-12 col-sm-12">
                <div class="row">
                  <label class="col-4 my-3 col-form-label text-right">
                    ชื่อ-สกุล
                    <span class="text-danger">*</span>
                  </label>
                  <div class="col-8 my-3">
                    <input type="text" class="form-control" formControlName="name" placeholder="นายสมชาย ใจดี"
                      (keyup)="onChange($event)" required>
                  </div>
                  <label class="col-4 my-3 col-form-label text-right">
                    โทรศัพท์
                    <span class="text-danger">*</span>
                  </label>
                  <div class="col-8 my-3">
                    <input type="text" class="form-control" MaxLength="10" autocomplete="off" formControlName="phone"
                      placeholder="0987654321" pattern="(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)"
                      (keyup)="onChange($event)" required>
                  </div>
                  <label class="col-4 my-3 col-form-label text-right">ที่อยู่</label>
                  <div class="col-8 my-3">
                    <textarea class="form-control" rows="3" style="width: 100%;" formControlName="address"
                      (keyup)="onChange($event)"></textarea>
                  </div>
                  <label class="col-4 my-3 col-form-label text-right">เลขที่ผู้เสียภาษี</label>
                  <div class="col-8 my-3">
                    <input type="text" class="form-control" pattern="(^[0-9]{13}$)" MaxLength="13" autocomplete="off" formControlName="tax"
                      (keyup)="onChange($event)">
                  </div>
                  <div class="col-12 mt-2">
                    <p class="text-center text-danger">
                      *ไม่สามารถเปลี่ยนแปลงข้อมูลในใบเสร็จได้
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </form>

          <div *ngIf="account">
            <!-- invalid case -->
            <div class="row mb-3 mt-3" *ngIf="!billerForm.valid">
              <div class="col">
                <button *ngIf="account.ACCOUNT_GROUP === 'Agency'" class="btn btn-outline-secondary mb-2 white"
                  [ngClass]="{'blue' : credit, 'white': !credit}" style="width: 100%;" (click)="validate()">
                  ชำระเงินด้วยบัตรเครดิต/เดบิต
                  <img class="mx-3" src="assets/credit-card.png" alt="" style="width: 25px;">
                </button>

                <button *ngIf="account.ACCOUNT_GROUP === 'Agency'" class="btn btn-outline-secondary mb-2"
                  [ngClass]="{'blue' : qrcode, 'white': !qrcode}" style="width: 100%;" (click)="validate()">
                  ชำระด้วย QR Code
                  <img class="mx-3" src="assets/qrcode.png" alt="" style="width: 20px;">
                </button>

                <button class="btn btn-outline-secondary mb-2" [ngClass]="{'blue' : transfer, 'white': !transfer}"
                  style="width: 100%;" (click)="validate()">
                  โอนผ่านบัญชีธนาคาร
                  <img class="mx-3" src="assets/bankbook.png" alt="" style="width: 25px;">
                </button>
              </div>
            </div>

            <!-- valid case -->
            <div class="row mb-3 mt-3" *ngIf="billerForm.valid">
              <div class="col">
                <button *ngIf="account.ACCOUNT_GROUP === 'Agency'" class="btn btn-outline-secondary mb-2 white"
                  [ngClass]="{'blue' : credit, 'white': !credit}" style="width: 100%;" (click)="transferType('credit')">
                  ชำระเงินด้วยบัตรเครดิต/เดบิต
                  <img class="mx-3" src="assets/credit-card.png" alt="" style="width: 25px;">
                </button>

                <button *ngIf="account.ACCOUNT_GROUP === 'Agency'" class="btn btn-outline-secondary mb-2"
                  [ngClass]="{'blue' : qrcode, 'white': !qrcode}" style="width: 100%;" (click)="transferType('qrcode')">
                  ชำระด้วย QR Code
                  <img class="mx-3" src="assets/qrcode.png" alt="" style="width: 20px;">
                </button>

                <div *ngIf="qrcode && qrStatus" class="my-5 text-center">
                  <div id="download" style="border: solid 5px #44237b;">
                    <div class="text-center mb-5" style="background: #44237b; margin: -5px -2px;">
                      <img src="assets/scb.png" alt="" style="width: 100px;">
                    </div>

                    <div class="d-flex justify-content-center mb-5">
                      <img [src]="qrBase64" alt="" class="img-fluid" style="width: 200px;">
                    </div>
                    <h4 class="text-center lifedi-color m-3">คณะจิตวิทยา จุฬาลงกรณ์มหาวิทยาลัย</h4>
                    <h6 class="text-center m-3">รายการ: {{ payment.TITLE }}</h6>
                    <p class="text-center m-3">ราคา: {{ amount | number }} บาท</p>
                    <p class="text-center m-3">เลขที่อ้างอิง: {{ payment.PAYMENT_ID }}</p>
                    <p class="text-center m-3">เวลาหมดอายุ: {{ expQR | dateTime:'full' }}</p>
                    <div style="height: 20px; margin: -2px -2px; background: #44237b;"></div>
                  </div>
                  <button mat-button style="color: #fff;" (click)="downloadImage(payment.TITLE)"
                    class="mx-auto d-block text-center m-3 bg-primary">ดาวน์โหลดรูปภาพ
                    <img src="assets/direct-download-white.png" alt="" style="width: 20px; margin-left: 3px;">
                  </button>

                  <button *ngIf="checkQRStatus" id="payment-button" type="submit" class="btn btn-success my-3"
                    (click)="checkStatus(payment.PAYMENT_ID)">
                    ตรวจสอบสถานะ
                    <img src="assets/refreshing.png" alt="" style="width: 20px; margin-left: 3px;">
                  </button>

                  <button *ngIf="!checkQRStatus" id="payment-button" type="submit" class="btn btn-secondary my-3"
                    [disabled]="true">
                    ตรวจสอบสถานะ
                    <img src="assets/refreshing.png" alt="" style="width: 20px; margin-left: 3px;">
                  </button>
                  <p *ngIf="!checkQRStatus" class="text-danger mb-3" style="margin-top: -11px; font-size: x-small;">
                    จะตรวจสอบได้อีกครั้งใน
                    <countdown [config]="{leftTime: 30}" (event)="handleEvent($event)"></countdown>
                  </p>
                  <p *ngIf="!checkQRStatus" class="text-danger m-2">ธุรกรรมยังไม่สำเร็จ</p>
                </div>

                <button class="btn btn-outline-secondary mb-2" [ngClass]="{'blue' : transfer, 'white': !transfer}"
                  style="width: 100%;" (click)="transferType('bank')">
                  โอนผ่านบัญชีธนาคาร
                  <img class="mx-3" src="assets/bankbook.png" alt="" style="width: 25px;">
                </button>

                <div class="text-center my-3" *ngIf="transfer">
                  <h4 *ngIf="account.ACCOUNT_GROUP === 'Agency'">
                    ธนาคารไทยพาณิชย์
                    <img src="assets/scb.png" class="mb-1" style="width: 50px;" alt="">
                  </h4>
                  <h4 *ngIf="account.ACCOUNT_GROUP !== 'Agency'">
                    ธนาคารกสิกรไทย
                    <img src="assets/kbank.png" class="mb-1" style="width: 50px;" alt="">
                  </h4>

                  <h4>ชื่อบัญชี {{ account.ACCOUNTING_NAME }}</h4>
                  <h4>เลขที่บัญชี {{ account.ACCOUNTING_ID }}</h4>
                  <button id="payment-button" type="submit" class="btn my-3" (click)="transferClick()"
                    style="background: #DE5C8B; color: #fff;">
                    แจ้งโอน
                  </button>
                  <p class="text-center text-danger">
                    *ใช้เวลาตรวจสอบ 2-3 วัน
                  </p>
                </div>

              </div>
            </div>
          </div>

        </mat-card>
      </div>
    </div>
  </div>

</div>

<div *ngIf="isPrint">
  <lifedi-payment-receipt [receiptDetail]="receiptDetail" [accountId]="accountId" [isSendMail]="true"
    (sendEmail)="sendMail($event)"></lifedi-payment-receipt>
</div>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>